
import InputNumber from "primevue/inputnumber";
import PTAValidacion from "@/validation/PayrollTransmission/PagoTercerosAnticipos";
import Tooltip from "@/components/layout/TooltipTransmission.vue";
import useVuelidate from "@vuelidate/core";

export default {
  components: {
    InputNumber,
    Tooltip,
  },
  props: {
    nomina: String,
  },
  setup(props) {
    let [PTA, validaciones] = new PTAValidacion().ObtenerReglasValidacion();

    const v$ = useVuelidate(validaciones, PTA, {
      $scope: props.nomina,
    });

    return {
      PTA,
      v$,
    };
  },
};
